<template>
  <div class="p-4 p-md-0">
    <div class="row mt-3 mb-4">
      <div class="col col-sm col-12">
        <em class="fas fa-calendar-plus text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Completar Evaluación
        </span>
      </div>
    </div>
    <validation-observer ref="completeEvaluationFormRef" novalidate tag="form">
      <div class="row">
        <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">Fecha de Evaluación:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-date-picker
              v-model="model.evaluationDate"
              class-container="w-100"
              custom-error-msg="La fecha es requerida."
              :error="errors[0]"
              format="dd/MMM./yyyy"
              :max-date="maxEvaluationDate"
              :min-date="minEvaluationDate"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
        </div>
        <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">
            Fecha redacción informe de evaluación:
          </div>
          <validation-provider
            v-slot="{ errors }"
            :rules="DateOfWritingRequired"
          >
            <custom-date-picker
              v-model="model.draftedDate"
              class-container="w-100"
              custom-error-msg="La fecha es requerida."
              :error="errors[0]"
              format="dd/MMM./yyyy"
              :max-date="maxDraftedDate"
              :min-date="minEvaluationDate"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
        </div>
        <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">Especialista:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="complete-evaluation-specialist"
              v-model="model.specialist"
              custom-error-msg="El especialista es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="data.specialistOrAssistantList"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">Archivo:</div>
          <validation-provider v-slot="{ errors }">
            <custom-file-input
              ref="documentFileRef"
              v-model="model.file"
              accept=".pdf"
              accept-terms-modal-title="Certificación"
              accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
              accept-terms-title="Acepto los términos y responsabilidades"
              accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
              allow-accept-terms
              :attachment-id="model.documentId"
              custom-error-msg="El documento de evaluación es requerido."
              display-style="normal"
              :error="errors[0]"
              label-position="left"
              :name="model.fileName"
              :on-download="onDownloadFile"
              @input="onChangeFile"
            />
          </validation-provider>
        </div>
      </div>
      <hr class="mt-4" />
      <div class="row">
        <div class="col-12 d-flex d-flex align-items-center">
          <check-box
            v-model="model.reevaluationRequired"
            class="chk__extended"
            text="Requiere evaluación a partir de la implementación de las
            recomendaciones ofrecidas en este informe de evaluación."
          />
        </div>
        <div class="col-12 d-flex d-flex align-items-center mt-4">
          <row-message
            :text="
              'El documento de evaluación no es requerido al momento de registrar la fecha de evaluación y la fecha de redacción del informe.'
            "
            warning
          />
        </div>
        <div v-if="model.reevaluationRequired" class="col-12 mt-4">
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <validation-provider v-slot="{ errors }" rules="required">
                <CustomDropDown
                  v-model="model.reevaluationTime"
                  custom-error-msg="El tiempo para reevaluación es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Tiempo para reevaluación:"
                  :options="reevaluationTimes"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>

            <div class="col-md-6 col-sm-12">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.reevaluationPurpose"
                  custom-error-msg="Favor explique con qué finalidad recomienda la reevaluación."
                  :error="errors[0]"
                  label="¿Con qué finalidad recomienda la reevaluación?"
                  type="text"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <div class="mt-5 mb-3 align-items-center d-flex justify-content-end">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 pl-3 pr-4"
        @click="$emit('cancel')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="onSaveHandler"
      />
    </div>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

//component libs
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CustomFileInput from 'CustomFileInput';
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import RowMessage from '@/components/common/RowMessage.vue';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//services
import { saveEvaluationDocuments as _saveEvaluationDocuments } from '@/services/uspqrp/contract.api.js';
import { getReevaluationTimes as _getReevaluationTimes } from '@/services/common/code.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';

export default {
  name: 'CompleteEvaluation',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    CustomDatePicker,
    CustomFileInput,
    CheckBox,
    CustomInput,
    CustomDropDown,
    RowMessage,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      evaluationDate: null,
      draftedDate: null,
      file: null,
      reevaluationRequired: null,
      reevaluationPurpose: null,
      reevaluationTimes: null,
      reevaluationTime: null,
    },
    rbOptions: [
      { label: 'Año(s)', value: true },
      { label: 'Mes(es)', value: false },
    ],
    reevaluationTimes: [],
  }),
  async mounted() {
    this.model.draftedDate = this.data.draftedDate;
    this.model.evaluationDate = this.data.contractServiceStartDate;
    this.model.documentId = this.data.initEvaluationDocument?.documentId;
    this.model.fileName = this.data.initEvaluationDocument?.fileName;
    this.model.reevaluationRequired = this.data.initEvaluationDocument?.reEvaluationRequired;
    this.model.reevaluationPurpose = this.data.initEvaluationDocument?.reEvaluationPurpose;

    this.isReEvaluationReadOnly =
      this.data.initEvaluationDocument?.fileName != false;

    if (this.data.SpecialistId) {
      this.model.specialist = this.data.specialistOrAssistantList.find(
        (x) => x.id == this.data.SpecialistId
      );
    } else if (this.data.specialistOrAssistantList?.length) {
      this.model.specialist = this.data.specialistOrAssistantList[0];
    }

    await this.getReevaluationTimes();
    this.model.reevaluationTime = this.reevaluationTimes.filter(
      (item) => item.id == this.data.initEvaluationDocument?.reEvaluationTimeId
    )[0];
  },
  computed: {
    specialistOrAssistantNames() {
      return this.data.specialistOrAssistantList?.length
        ? this.data.specialistOrAssistantList
            .map((x) => this.$options.filters.capitalize(x.name))
            .join(', ')
        : null;
    },
    minEvaluationDate() {
      const d = new Date(
        this.model.evaluationDate || this.data.contractServiceStartDate
      );
      return new Date(d.setDate(d.getDate() - 1));
    },
    maxEvaluationDate() {
      if (!this.data.canceledByEgress) return new Date();
      else return new Date(this.data.egressedDate);
    },
    minDraftedDate() {
      const d = new Date(this.data.contractServiceStartDate);
      return d.setDate(d.getDate() - 1);
    },
    maxDraftedDate() {
      if (this.data.canceledByEgress) return new Date(this.data.egressedDate);

      const d = new Date(
        this.model.evaluationDate || this.data.contractServiceStartDat
      );
      return new Date(d.setDate(d.getDate() + 15));
    },
    DateOfWritingRequired() {
      if (this.model.file && this.model.file.name) return 'required';
      return '';
    },
  },
  methods: {
    async getReevaluationTimes() {
      const { data } = await _getReevaluationTimes();
      this.reevaluationTimes = data.filter((x) => !x.isDisabledTime);
    },
    async onSaveEvaluationDocuments() {
      const params = objectToFormData(
        {
          ...this.model,
          contractId: this.data.contractId,
          academicYearId: this.data.academicYearId,
          companyId: this.data.companyId,
          studentSieId: this.data.studentSieId,
          requestServiceId: this.data.requestServiceId,
          disciplineTypeId: this.data.disciplineTypeId,
          evaluationAdministeredBy: this.specialistOrAssistantNames,
          draftedDate: moment(this.model.draftedDate)
            .locale('es-PR')
            .format('DD/MMM/YYYY'),
          reportDate: moment(this.model.reportDate)
            .locale('es-PR')
            .format('DD/MMM/YYYY'),
          file: this.model.file,
          reevaluationTimeId: this.model.reevaluationTime?.id,
          specialistId: this.model.specialist?.id,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      const { data: result } = await _saveEvaluationDocuments(params).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        }
      );
      const confirmationMessage = this.model.file?.name
        ? 'La evaluación ha sido completada exitosamente.'
        : 'La fecha de evaluación ha sido registrada exitosamente.';

      if (result) {
        this.ShowToast('Proceso Exitoso', confirmationMessage, 'success');
        this.$emit('saved', result);
      }
    },
    async onSaveHandler() {
      //this.$emit('saved', true);

      const isFormValid = await this.$refs.completeEvaluationFormRef.validate();

      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const confirmationMessage = this.model.file?.name
        ? `¿Está seguro(a) que desea completar la evaluación?`
        : `¿Esta seguro(a) que desea registrar la fecha de evaluación?`;

      const answer = await this.ShowCancelModal(
        'Confirmación',
        confirmationMessage,
        'Sí',
        'No'
      );
      if (!answer) return;

      this.onSaveEvaluationDocuments(this.documents);
    },
    onDownloadFile(id) {
      _downloadDocumentByAttachmentId(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
    async onChangeFile(file) {
      this.model.file = file;
      this.model.fileName = file?.name;
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.chk__extended) {
  label {
    div {
      margin-top: 3px;
    }
  }
}
</style>
